import { usePlayer } from '@/composables/usePlayer';
import i18n, { loadLocaleMessages } from '@/plugins/i18n';
import { useLegalsStore, useSiteStatusStore, useTournamentsStore, useBannersStore, useLocalizationsStore } from '@/stores';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';

export function useLocalization() {
    const { toUpdateLanguageCode, isPlayer } = usePlayer();
    const legalsStore = useLegalsStore();
    const siteStatusStore = useSiteStatusStore();
    const tournamentStore = useTournamentsStore();
    const bannersStore = useBannersStore();
    const localizationsStore = useLocalizationsStore();
    const route = useRoute();
    const currentLocale = ref(localStorage.getItem('locale') || 'en');
    const defaultLanguageCode = computed(() => localizationsStore.defaultLanguageCode);
    const isBlockedSite = computed(() => siteStatusStore.isBlocked || siteStatusStore.isMaintenance);
    const localizations = computed(() => localizationsStore.localizations);
    const changeLocale = async (code: string) => {
        if (code === i18n.global.locale.value) return;

        if (isPlayer.value && !isBlockedSite.value) {
            toUpdateLanguageCode(code);
        }

        await loadLocaleMessages(code);
        i18n.global.locale.value = code;
        localStorage.setItem('locale', code);
        currentLocale.value = code;

        if (route.path.includes('terms') || route.path.includes('tournament')) {
            location.reload();
        } else {
            legalsStore.toResetLegals();
            tournamentStore.toResetTournaments();
            bannersStore.toResetBanners();
        }
    };
    const toGetDefaultLanguageCode = async () => {
        try {
            await localizationsStore.awaitGetDefaultLanguageCode();
        } catch (error) {
            console.error('Error getting default language code', error);
        }
    };
    const toGetLocalizations = async () => {
        try {
            await localizationsStore.awaitGetLocalizations();
        } catch (error) {
            console.error('Error getting localizations', error);
        }
    };
    return {
        currentLocale,
        changeLocale,
        toGetDefaultLanguageCode,
        defaultLanguageCode,
        toGetLocalizations,
        localizations
    };
}
